export const isValidInvitationCode = (invitationCode) => (/([0-9a-zA-Z]){64}/.test(invitationCode))
